import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { forkJoin, Observable, of } from "rxjs";
import { filter, take, concatMap, catchError, map } from "rxjs/operators";
import { Paginated } from "voxloud-types/dist/models/common";
import { AppConfig } from "../../../../environments/environment";
import { AccountFacade } from "../../../account/store/facade";
import {
  SessionDTO,
  SubscriptionLite,
} from "../../../account/store/states-models";
import { Integration, INTEGRATION_STATUS } from "voxloud-types/dist/models/integrations";
import { Logger, LoggerService } from "../../../core/services/logger";

@Injectable({ providedIn: 'root' })
export class IntegrationsService {
  public companyId: string;
  public hasAiAgent: boolean = false;
  private userId: string;
  private shortlyDeletedGuid: string[] = [];
  private DEFAULT_PAGE_SIZE = 200;
  private logger: Logger;

  constructor(
    private http: HttpClient,
    private readonly accountFacade: AccountFacade,
    private readonly loggerService: LoggerService,
  ) {
    this.logger = this.loggerService.getLoggerInstance('IntegrationsService');
    accountFacade.subscription$
      .pipe(filter((s) => ![null, undefined].includes(s)))
      .subscribe((sub: SubscriptionLite) => {
        this.companyId = sub?.company_id;
      });
    accountFacade.session$
      .pipe(filter((s) => ![null, undefined].includes(s)))
      .subscribe((session: SessionDTO) => {
        this.userId = session.user_aggregate_id;
      });
  }

  private wasGuidDeleted(guid: string) {
    if (guid) return this.shortlyDeletedGuid.includes(guid);
    return false;
  }

  public getIntegrations(id?: number): Observable<Paginated<Integration>> {
    return this.http.get<Paginated<Integration>>(
      `${AppConfig.endpointURL}/v1/integrations?company_id=${this.companyId ? this.companyId : id}&size=${this.DEFAULT_PAGE_SIZE}`,
    );
  }

  public fillhasAiAgent(): Observable<void> {
    return forkJoin({
      romulusIntegration: this.findIntegrationByPlatformName('ROMULUS').pipe(
        map(res => res.content[0]),
        catchError(e => { this.logger.error(e); return of(undefined); })
      ),
      vapiIntegration: this.findIntegrationByPlatformName('VAPI').pipe(
        map(res => res.content[0]),
        catchError(e => { this.logger.error(e); return of(undefined); })
      )
    }).pipe(
      map(({ romulusIntegration, vapiIntegration }: { romulusIntegration?: Integration; vapiIntegration?: Integration }) => {
        this.hasAiAgent =
          romulusIntegration?.status === INTEGRATION_STATUS.ACTIVE ||
          vapiIntegration?.status === INTEGRATION_STATUS.ACTIVE;
      })
    );
  }

  public findIntegrationByPlatformName(
    name: string,
    companyId?: number,
  ): Observable<Paginated<Integration>> {
    return this.http.get<Paginated<Integration>>(
      `${AppConfig.endpointURL}/v1/integrations?platform_name=${name}&size=${this.DEFAULT_PAGE_SIZE}&company_id=${companyId ? companyId : this.companyId}`,
    );
  }
}
